import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { loadState, saveState } from "signoxe/store/localStorage";
import fetchAll from "./actions/fetchAll";
import { Main } from "./containers";
import { getLoginState } from "./selectors";
import configureStore from "./store/configureStore";

import { APP_URL, ADMIN_ROOT } from "./constants/config";
import { HtmlDragDropContext } from "./components";

const store = configureStore({
  uiState: loadState("uiState"),
  filters: loadState("filters"),
});

const loginState = getLoginState(store.getState());

store.subscribe(() => {
  const state = store.getState();
  saveState("uiState", state.uiState);
  saveState("filters", state.filters);
});

if (loginState) {
  store.dispatch(fetchAll());
}

// This code allows us to login as any user to the frontend from the backend to diagnose issues
// faced by a user. The backend will load the frontend page in an iframe and send it the login
// information via the postMessage API. The listens for that message and stores the login info
// in the browser.
window.addEventListener("message", (e) => {
  // Only allow communication from the admin panel.
  if (e.origin !== ADMIN_ROOT) {
    return;
  }
  const payload = JSON.parse(e.data);

  localStorage.setItem("username", payload.username);
  localStorage.setItem("token", payload.token);
  // Redirect to the app page in the main browser window.
  window.parent.location = APP_URL;
});

const spinner = document.getElementById('spinner');

if (spinner && !spinner.hasAttribute('hidden')) {
  spinner.setAttribute('hidden', 'true');
}

const App = () => (
  <Provider store={store}>
    <HtmlDragDropContext>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </HtmlDragDropContext>
  </Provider>
);

export default App;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/app.js